// Crayo, Legal, About, Contact pages + 404
import React from 'react';

const { Icon, Page, navigate } = window;

function LegalShell({ title, children, last = 'Aprilie 2026' }) {
  return (
    <Page>
      <section style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div className="container-narrow">
          <a href="#/" onClick={(e)=>{e.preventDefault();navigate('/');}} style={{ fontSize: 13, color: 'var(--muted)', display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 24 }}>
            <span style={{ transform: 'rotate(180deg)', display: 'inline-flex' }}><Icon.Arrow size={14} /></span> Înapoi acasă
          </a>
          <h1 style={{ marginBottom: 8 }}>{title}</h1>
          <p style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 40 }}>Ultima actualizare: {last}</p>
          <div className="legal-body">{children}</div>
        </div>
      </section>
      <style>{`
        .legal-body { font-size: 16px; line-height: 1.75; color: #2a2a2a; }
        .legal-body h2 { margin-top: 40px; margin-bottom: 12px; font-size: 22px; }
        .legal-body h3 { margin-top: 24px; margin-bottom: 8px; font-size: 17px; }
        .legal-body p { margin-bottom: 16px; }
        .legal-body ul { padding-left: 22px; margin-bottom: 16px; }
        .legal-body li { margin-bottom: 6px; }
        .legal-body a { color: var(--terracotta); text-decoration: underline; text-underline-offset: 3px; }
      `}</style>
    </Page>
  );
}

function TermsPage() {
  return (
    <LegalShell title="Termeni și condiții">
      <h2>1. Obiectul contractului</h2>
      <p>Crayo este un serviciu digital care generează pagini de colorat în alb-negru pornind de la fotografiile încărcate de utilizator. Operatorul serviciului este <strong>SHIPDRONES SRL</strong>, cu sediul în Str. Marin Preda nr. 5, Alba Iulia, jud. Alba, România, CUI 46378099, înregistrată la Oficiul Registrului Comerțului sub nr. J01/831/2022 (EUID: ROONRC.J1/831/2022). „Crayo" este denumirea comercială a produsului.</p>
      <p>Prin plasarea unei comenzi, utilizatorul acceptă termenii de mai jos și încheie un contract la distanță cu SHIPDRONES SRL.</p>

      <h2>2. Prețuri și plată</h2>
      <p>Prețurile afișate pe site sunt în RON și includ TVA. Plata se efectuează online, prin procesatorul de plăți Stripe, cu cardul bancar. SHIPDRONES SRL nu stochează datele cardului, acestea sunt procesate direct și securizat de Stripe.</p>
      <p>După confirmarea plății, utilizatorul primește pe email un link către fișierul PDF generat. Linkul este valabil 30 de zile de la emitere.</p>

      <h2>3. Livrare digitală și renunțarea la dreptul de retragere</h2>
      <p>Serviciul constă într-un conținut digital livrat imediat după plată. Conform Art. 16 lit. m) din OUG 34/2014 (transpunerea Directivei UE 2011/83), consumatorul își pierde dreptul legal de retragere de 14 zile în momentul în care începe livrarea conținutului digital.</p>
      <p>La checkout, utilizatorul confirmă explicit, prin bifarea a două casete separate, că este de acord cu livrarea imediată și că înțelege că renunță la dreptul de retragere. Fără aceste două confirmări, comanda nu poate fi plasată.</p>

      <h2>4. Proprietate intelectuală</h2>
      <p>Utilizatorul rămâne proprietarul fotografiilor originale încărcate. Asupra paginilor generate, utilizatorul primește un drept neexclusiv de folosință personală și familială (printare, colorare, păstrare).</p>
      <p>Statutul de copyright asupra conținutului generat cu ajutorul inteligenței artificiale este, la momentul actual, incert atât în România, cât și la nivel european. Crayo nu garantează că rezultatul generat este protejat prin copyright și nu oferă asistență juridică în acest sens.</p>

      <h2>5. Utilizare permisă</h2>
      <p>Paginile generate pot fi folosite pentru uz personal și familial. Nu este permisă redistribuirea comercială, revânzarea sau publicarea pe platforme terțe fără acordul scris al SHIPDRONES SRL.</p>

      <h2>6. Garanție de satisfacție 14 zile</h2>
      <p>Oferim o garanție voluntară de satisfacție de 14 zile, în plus față de cadrul legal descris la secțiunea 3. Dacă din orice motiv nu ești mulțumit de rezultat, scrie-ne la <a href="mailto:salut@crayo.ro">salut@crayo.ro</a> în maxim 14 zile de la cumpărare și îți returnăm integral suma plătită, pe aceeași metodă de plată folosită la achiziție, în 5–7 zile lucrătoare.</p>

      <h2>7. Limitarea răspunderii</h2>
      <p>Răspunderea SHIPDRONES SRL este limitată la suma efectiv plătită de utilizator pentru comanda în cauză. SHIPDRONES SRL nu răspunde pentru daune indirecte, pierderi de date sau imposibilitatea de a folosi serviciul din cauze externe (întreruperi ale furnizorilor de servicii, probleme de rețea etc.).</p>

      <h2>8. Legea aplicabilă</h2>
      <p>Contractul este guvernat de legea română. Orice litigiu se soluționează pe cale amiabilă sau, în caz contrar, de instanțele competente din România.</p>

      <h2>9. Contact</h2>
      <p>Pentru întrebări legate de acești termeni: <a href="mailto:salut@crayo.ro">salut@crayo.ro</a>.</p>
    </LegalShell>
  );
}

function PrivacyPage() {
  return (
    <LegalShell title="Politica de confidențialitate">
      <h2>1. Operator de date</h2>
      <p>Operatorul datelor cu caracter personal este <strong>SHIPDRONES SRL</strong>, CUI 46378099, Reg. Com. J01/831/2022, cu sediul în Str. Marin Preda nr. 5, Alba Iulia, jud. Alba, România. „Crayo" este denumirea comercială a produsului. Pentru orice întrebare legată de prelucrarea datelor, ne poți scrie la <a href="mailto:salut@crayo.ro">salut@crayo.ro</a>.</p>

      <h2>2. Ce date colectăm</h2>
      <ul>
        <li><strong>Adresa de email</strong>, pentru livrarea produsului și comunicări legate de comandă.</li>
        <li><strong>Fotografiile încărcate</strong>, pentru generarea paginilor de colorat.</li>
        <li><strong>Detaliile de plată</strong>, sunt procesate direct de Stripe. SHIPDRONES SRL nu are acces la și nu stochează numerele de card.</li>
        <li><strong>Date tehnice</strong>, adresa IP, tipul browserului, paginile accesate (doar cu consimțământ pentru analiză).</li>
      </ul>

      <h2>3. Temei legal</h2>
      <p>Prelucrăm datele pe baza executării contractului (Art. 6(1)(b) GDPR) pentru livrarea serviciului și pe baza obligațiilor legale (Art. 6(1)(c) GDPR) pentru evidența contabilă.</p>

      <h2>4. Subîmputerniciți</h2>
      <p>Colaborăm cu furnizori de servicii care pot procesa datele tale în numele nostru:</p>
      <ul>
        <li><strong>OpenAI</strong>, generarea paginilor de colorat prin API (procesare temporară a fotografiilor).</li>
        <li><strong>Google Cloud (Cloud Run, Cloud Storage, Firestore)</strong>, găzduire backend și stocare temporară a fișierelor, în regiunea europeană.</li>
        <li><strong>Stripe</strong>, procesarea plăților și emiterea facturilor.</li>
        <li><strong>Cloudflare</strong>, livrare CDN și hosting frontend.</li>
        <li><strong>Resend</strong>, trimitere email tranzacțional (livrarea linkului de descărcare).</li>
        <li><strong>Sentry</strong>, monitorizare erori tehnice; nu primește fotografii sau conținutul PDF-urilor.</li>
      </ul>

      <h2>5. Transferuri internaționale</h2>
      <p>O parte dintre subîmputerniciți (ex: Stripe, OpenAI, Resend, Sentry) procesează datele în Statele Unite. Aceste transferuri sunt acoperite prin EU-US Data Privacy Framework și, acolo unde este cazul, prin Clauze Contractuale Standard (SCCs) aprobate de Comisia Europeană.</p>

      <h2>6. Retenția datelor</h2>
      <ul>
        <li><strong>Fotografiile originale</strong>, șterse automat după 72 de ore de la încărcare.</li>
        <li><strong>PDF-ul generat</strong>, disponibil timp de 30 de zile de la comandă.</li>
        <li><strong>Date despre comandă (factură, email, sumă)</strong>, păstrate 10 ani, conform obligațiilor contabile din legislația română.</li>
      </ul>

      <h2>7. Drepturile tale</h2>
      <p>Ai dreptul de acces, rectificare, ștergere, opoziție la prelucrare, restricționare și portabilitate a datelor. Pentru a le exercita, trimite un email la <a href="mailto:salut@crayo.ro">salut@crayo.ro</a>.</p>
      <p>Ai, de asemenea, dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP), <a href="https://www.dataprotection.ro" target="_blank" rel="noopener">dataprotection.ro</a>.</p>

      <h2>8. Modificări</h2>
      <p>Putem actualiza această politică. Vom marca modificările prin data ultimei actualizări, afișată în partea de sus a paginii.</p>
    </LegalShell>
  );
}

function CookiesPage() {
  // Lazy access to the consent helpers exposed on `window` by src/consent.js.
  // Importing directly would force a refactor of this prerendered module's
  // dependency graph; the global is set on app boot in main.jsx before any
  // component renders, so it's safe at runtime.
  const handleChangeConsent = () => {
    if (typeof window !== 'undefined' && window.crayoConsent) {
      window.crayoConsent.clearConsent();
      // Banner re-renders automatically via the crayo-consent-changed event.
      // Scroll up so the user sees it pop in from the bottom of the viewport.
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <LegalShell title="Politica de cookies">
      <h2>Pe scurt</h2>
      <p>Crayo folosește cookies în trei categorii: <strong>necesare</strong> (mereu active, fără ele site-ul nu funcționează), <strong>analiză</strong> (opționale, ne ajută să înțelegem cum e folosit site-ul) și <strong>marketing</strong> (opționale, ne ajută să măsurăm campaniile pe Facebook). La prima vizită îți arătăm un banner unde îți alegi preferințele, iar mai jos găsești și un buton ca să le schimbi oricând.</p>

      <h2>1. Cookies necesare (mereu active)</h2>
      <ul>
        <li><strong>localStorage</strong> — păstrăm ID-ul sesiunii tale de creație în browserul tău, până finalizezi comanda. Nu se trimite nicăieri în afara propriului dispozitiv.</li>
        <li><strong>Stripe</strong> (stripe.com) — pentru pagina de plată securizată. Stripe poate seta cookies proprii pentru detectarea fraudei și 3D Secure. Strict necesar pentru a accepta plăți cu cardul.</li>
        <li><strong>Sentry</strong> (sentry.io) — captează erorile tehnice ale site-ului. Nu folosește cookies pentru tracking; nu are acces la pozele tale.</li>
      </ul>
      <p>Aceste tehnologii se încarcă fără să-ți cerem consimțământ pentru că sunt necesare execuției contractului (procesarea comenzii) și interesului legitim de a menține site-ul funcțional.</p>

      <h2>2. Cookies de analiză (opționale)</h2>
      <ul>
        <li><strong>Google Analytics 4</strong> — cookies <code>_ga</code>, <code>_gid</code>, <code>_gat</code>, retenție până la 14 luni. Operator: Google Ireland Ltd. Folosim Google Consent Mode v2: dacă nu ai acceptat analiza, scriptul rulează în mod „denied" — nu setează cookies și nu trimite date.</li>
        <li><strong>Microsoft Clarity</strong> — cookies <code>_clck</code>, <code>_clsk</code>, <code>CLID</code>, plus alte cookies pe domeniul <code>clarity.ms</code>. Operator: Microsoft Ireland Operations Ltd. Clarity înregistrează interacțiunile cu pagina (mișcări de mouse, click-uri, scroll, hărți de căldură) ca să înțelegem unde se blochează utilizatorii. Câmpurile de formular și textul introdus sunt mascate automat — nu vedem ce scrii. Înregistrările se păstrează 30 de zile. Nu se încarcă deloc dacă nu ai acceptat analiza.</li>
        <li><strong>Cloudflare Web Analytics</strong> — nu folosește cookies. Cloudflare măsoară traficul edge-side, fără identificatori persistenti pe dispozitivul tău. Listat aici pentru transparență; nu necesită consimțământ.</li>
      </ul>

      <h2>3. Cookies de marketing (opționale)</h2>
      <ul>
        <li><strong>Meta Pixel</strong> — cookies <code>_fbp</code> (90 de zile) și, dacă vii dintr-un click pe reclamă Meta, <code>_fbc</code>. Operator: Meta Platforms Ireland Ltd. Sunt folosite pentru a măsura conversiile reclamelor noastre de pe Facebook și Instagram și pentru a optimiza livrarea reclamelor.</li>
        <li><strong>Conversions API (Meta)</strong> — un canal server-to-server, fără cookies, prin care backendul nostru raportează achizițiile către Meta cu același <code>event_id</code> ca evenimentul din browser, ca să nu se contabilizeze de două ori. Transferă către Meta: emailul tău în formă hash-uită SHA-256, valoarea comenzii, moneda, sursa UTM. Necesită același consimțământ de marketing ca Pixelul, pentru că datele tale sunt transferate către Meta în Irlanda și SUA.</li>
      </ul>

      <h2>Servicii terțe — listă scurtă</h2>
      <ul>
        <li>Stripe (necesare) — plăți</li>
        <li>Sentry (necesare) — monitorizare erori</li>
        <li>Google Analytics 4 (analiză) — măsurarea traficului</li>
        <li>Microsoft Clarity (analiză) — înregistrări sesiuni și hărți de căldură</li>
        <li>Cloudflare Web Analytics (fără cookies) — măsurarea traficului edge-side</li>
        <li>Meta Pixel + Conversions API (marketing) — măsurarea reclamelor</li>
      </ul>

      <h2>Schimbă-ți consimțământul</h2>
      <p>Apasă butonul de mai jos pentru a re-deschide bannerul și a-ți modifica preferințele. Poți, de asemenea, să ștergi datele de site din setările browserului tău.</p>
      <p>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={handleChangeConsent}
          style={{ marginTop: 8 }}
        >
          Schimbă consimțământul
        </button>
      </p>

      <h2>Cum îți cureți browserul</h2>
      <p>Poți șterge oricând datele de site (inclusiv localStorage și cookies) din setările browserului tău, secțiunea Confidențialitate. Instrucțiuni pentru Chrome, Firefox, Safari și Edge sunt disponibile în documentația oficială a fiecărui browser.</p>

      <h2>Contact</h2>
      <p>Pentru întrebări: <a href="mailto:salut@crayo.ro">salut@crayo.ro</a>.</p>
    </LegalShell>
  );
}

function AboutPage() {
  return (
    <Page>
      <section style={{ paddingTop: 56, paddingBottom: 80 }}>
        <div className="container-narrow">
          <a href="#/" onClick={(e)=>{e.preventDefault();navigate('/');}} style={{ fontSize: 13, color: 'var(--muted)', display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 24 }}>
            <span style={{ transform: 'rotate(180deg)', display: 'inline-flex' }}><Icon.Arrow size={14} /></span> Înapoi
          </a>
          <div className="eyebrow">Despre noi</div>
          <h1 style={{ marginBottom: 32 }}>Am făcut Crayo cu gândul la copiii din familiile noastre.</h1>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginBottom: 40 }} className="about-imgs">
            <div style={{ aspectRatio: '4/3', borderRadius: 16, overflow: 'hidden', background: 'var(--soft)' }}>
              <img src="assets/photos/about-1.jpg" alt="Familie fericită" loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', display: 'block', transform: 'scale(1.25)', transformOrigin: 'center top' }} />
            </div>
            <div style={{ aspectRatio: '4/3', borderRadius: 16, overflow: 'hidden', border: '1px solid var(--soft)', background: 'var(--paper)' }}>
              <img src="assets/sketches/about.png" alt="Pagină de colorat, familie" loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </div>
          </div>

          <div style={{ fontSize: 18, lineHeight: 1.7, color: '#2a2a2a' }}>
            <p style={{ marginBottom: 20 }}>
              Sunt un inginer AI de 25 de ani din România și construiesc Crayo singur. A pornit dintr-o seară în care mătușa iubitei mele ne-a trimis o poză cu fetița ei nou-născută — atât de mică și de cuminte încât mi-am imaginat ce frumos ar fi, peste câțiva ani, să țină în mână o carte cu propriile ei poze, transformate în pagini de colorat. Așa s-a născut Crayo: un loc unde amintirile capătă creioane.
            </p>
            <p style={{ marginBottom: 20 }}>
              Credem că cele mai bune cadouri nu sunt cele scumpe, ci cele care poartă o amintire. O carte de colorat cu poze de familie e, în felul ei, și jucărie, și album, și petrecere de sâmbătă după-amiaza. Copilul colorează, iar tu îți amintești.
            </p>
            <p>
              Construim Crayo încet, cu grijă pentru detalii. Fără abonamente, fără reclame, fără bătaie de cap. O dată plătești, o dată printezi, de multe ori colorezi.
            </p>
          </div>

          <div style={{ marginTop: 48, padding: 24, borderTop: '1px solid var(--soft)', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
            <div style={{ fontSize: 14, color: 'var(--muted)' }}>
              Ai o idee sau o întrebare? <a href="mailto:salut@crayo.ro" className="link">salut@crayo.ro</a>
            </div>
            <a href="#/create" onClick={(e)=>{e.preventDefault();navigate('/create');}} className="btn btn-primary">Încearcă gratuit</a>
          </div>
        </div>
      </section>
      <style>{`
        @media (max-width: 640px) { .about-imgs { grid-template-columns: 1fr !important; } }
      `}</style>
    </Page>
  );
}

function ContactPage() {
  return (
    <Page>
      <section style={{ paddingTop: 56, paddingBottom: 80 }}>
        <div className="container-narrow">
          <a href="#/" onClick={(e)=>{e.preventDefault();navigate('/');}} style={{ fontSize: 13, color: 'var(--muted)', display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 24 }}>
            <span style={{ transform: 'rotate(180deg)', display: 'inline-flex' }}><Icon.Arrow size={14} /></span> Înapoi
          </a>
          <div className="eyebrow">Contact</div>
          <h1 style={{ marginBottom: 24 }}>Scrie-ne.</h1>
          <p style={{ color: 'var(--muted)', fontSize: 17, marginBottom: 40, maxWidth: 540 }}>
            Răspundem în cel mult 48 de ore — uneori mai repede, dacă nu colorăm.
          </p>

          <div className="card" style={{ padding: 24, marginBottom: 32 }}>
            <div style={{ fontSize: 12, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600 }}>Email</div>
            <div style={{ fontFamily: 'Fraunces, serif', fontSize: 22, marginTop: 8 }}>
              <a href="mailto:salut@crayo.ro" className="link">salut@crayo.ro</a>
            </div>
            <p style={{ fontSize: 13, color: 'var(--muted)', marginTop: 14, marginBottom: 0 }}>
              Aceeași adresă pentru întrebări generale, confidențialitate (GDPR) și — conform <strong>Regulamentului DSA (UE) 2022/2065</strong> — pentru notificări privind conținut ilegal.
            </p>
          </div>
        </div>
      </section>
    </Page>
  );
}

function NotFoundPage() {
  return (
    <Page>
      <section style={{ paddingTop: 80, paddingBottom: 80 }}>
        <div className="container-narrow" style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginBottom: 24, opacity: 0.8 }}>
            <Icon.Balloon size={44} />
            <Icon.Cat size={44} />
            <Icon.House size={44} />
          </div>
          <h1 style={{ marginBottom: 16 }}>Pagina asta nu există…</h1>
          <p style={{ color: 'var(--muted)', fontSize: 17, marginBottom: 32 }}>
            …dar mai avem multe altele de colorat.
          </p>
          <a href="#/" onClick={(e)=>{e.preventDefault();navigate('/');}} className="btn btn-primary btn-lg">
            Înapoi acasă <Icon.Arrow />
          </a>
        </div>
      </section>
    </Page>
  );
}

Object.assign(window, { TermsPage, PrivacyPage, CookiesPage, AboutPage, ContactPage, NotFoundPage });
